module.exports = __webpack_public_path__ + "img/search.ebcead1b.svg";